import React, { useState } from "react";
import { encryptStorage } from "../../../constants/EncryptStorage";
import SearchEventAttendance from "./SearchEventAttendance";
import { GetLanguageString, NoResult } from "../../helper/Components";
import { useEffect } from "react";
import { ApiEvent } from "../ApiEvent";
import { Col, Row, Table, Button, ButtonGroup } from "reactstrap";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";
import { GetCustomStyles } from "../../helper/Method";
import { saveAs } from "file-saver";
import { GetSelectedLanguage } from "../../helper/Method";
import { LoadingSpinner } from "../../../constants/const";
import swal from "sweetalert";
import { ShowToast } from "../../shared/ShowToast";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
const UnitWiseEventAttendance = () => {
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [loading, setLoading] = useState(false);
  const [searchButton, setSearchButton] = useState(false);
  const [data, setData] = useState({});

  let tempDate = new Date();
  tempDate.setUTCDate(1);
  const [searchEventWiseAttendanceModel, setSearchEventWiseAttendanceModel] =
    useState({
      unit: { value: loggedInUnitId, lable: "" },
      isSubUnits: true,
      startDate: tempDate,
      endDate: new Date(),
      eventTypeIds: [],
    });

  useEffect(() => {
    if (searchButton) {
      setLoading(true);
      ApiEvent()
        .GetUnitWiseEventAttendanceReport(searchEventWiseAttendanceModel)
        .then((res) => {
          setData(res.data.report);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [searchButton, searchEventWiseAttendanceModel]);
  const downloadExcel = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_excel"));
      ApiEvent()
        .GetUnitWiseEventAttendanceExcelReport(searchEventWiseAttendanceModel)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "NazamWiseIjtimaReport.xlsx");
          ShowToast(toastId, "downloaded_excel", "success");
        })
        .catch((err) => {
          console.log(err);
          ShowToast(toastId, "Failed to download Excel.", "error");
        })
        .then(() => {});
    }
  };
  const downloadPdf = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_pdf"));
      ApiEvent()
        .GetUnitWiseEventAttendancePdfReport(searchEventWiseAttendanceModel)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/pdf",
          });
          saveAs(blob, "NazamWiseIjtimaReport.pdf");
          ShowToast(toastId, "downloaded_pdf", "success");
        })
        .catch((err) => {
          console.log(err);
          ShowToast(toastId, "Failed to download Pdf.", "error");
        })
        .then(() => {
          setLoading(false);
        });
    }
  };
  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="common_generate_report" />}</h5>
        </div>
        <SearchEventAttendance
          searchEventWiseAttendanceModel={searchEventWiseAttendanceModel}
          setSearchEventWiseAttendanceModel={setSearchEventWiseAttendanceModel}
          setSearchButton={setSearchButton}
        />
      </div>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {searchButton ? (
        <div className="ibox">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="quick_event_reports_button3" />}</h5>
            <ButtonGroup className={GetCustomStyles().btn_style}>
              <Button color="default" size="sm" onClick={downloadExcel}>
                <RiFileExcel2Line
                  size={15}
                  color="#009440"
                  style={{ marginRight: 3, marginBottom: 1 }}
                />
                {<GetLanguageString props="member_report_export_excel" />}
              </Button>
              <Button color="default" size="sm" onClick={downloadPdf}>
                <RiFilePdf2Line
                  size={15}
                  color="#FF0000"
                  className={GetCustomStyles().fa_style}
                />
                {<GetLanguageString props="member_report_export_pdf" />}
              </Button>
            </ButtonGroup>
          </div>
          <div className="ibox-content">
            {!loading ? (
              data !== undefined &&
              data !== null &&
              Object.keys(data).length !== 0 ? (
                <div
                  className="panel-body ibox-center"
                  style={{ marginLeft: 100, marginRight: 100 }}
                >
                  <Table className="table-bordered m-b-none">
                    <thead>
                      <tr>
                        <th
                          className="text-center"
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <GetLanguageString props="member_member_detail_unit_history" />
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <GetLanguageString props="report_member_mubtadi" />
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <GetLanguageString props="report_member_multazim" />
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <GetLanguageString props="report_member_mutazir" />
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <GetLanguageString props="report_member_tawajah_talab" />
                        </th>
                        <th
                          style={{
                            border: "2px solid black",
                          }}
                        >
                          <GetLanguageString props="report_vacant_responsibilities_total" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <tr key={index}>
                          <td
                            className="text-center ur"
                            style={{
                              border: "1px solid black",
                            }}
                          >
                            <Row>
                              <Col md="4"></Col>
                              <Col md="4">
                                <h3>{item.name} </h3>
                              </Col>
                              <Col md="1" className="m-1">
                                <span
                                  className="label label-success"
                                  style={{ borderRadius: "50%" }}
                                >
                                  {item.eventCounts}
                                </span>
                              </Col>
                              <Col md="4"></Col>
                            </Row>
                          </td>
                          <td
                            style={{
                              border:
                                item.name !== "ٹوٹل"
                                  ? "1px solid black"
                                  : "2px solid black",
                            }}
                          >
                            {`${item.attendeMubtadi ?? 0} / ${
                              item.totalMubtadi ?? 0
                            }`}{" "}
                            (
                            {item.mubtadi
                              ? item.mubtadi.toFixed(2) + "%"
                              : "0.0%"}
                            )
                          </td>
                          <td
                            style={{
                              border:
                                item.name !== "ٹوٹل"
                                  ? "1px solid black"
                                  : "2px solid black",
                            }}
                          >
                            {`${item.attendeMultazim ?? 0} / ${
                              item.totalMultazim ?? 0
                            }`}{" "}
                            (
                            {item.multazim
                              ? item.multazim.toFixed(2) + "%"
                              : "0.0%"}
                            )
                          </td>
                          <td
                            style={{
                              border:
                                item.name !== "ٹوٹل"
                                  ? "1px solid black"
                                  : "2px solid black",
                            }}
                          >
                            {`${item.attendeMutazir ?? 0} / ${
                              item.totalMutazir ?? 0
                            }`}{" "}
                            (
                            {item.mutazir
                              ? item.mutazir.toFixed(2) + "%"
                              : "0.0%"}
                            )
                          </td>
                          <td
                            style={{
                              border:
                                item.name !== "ٹوٹل"
                                  ? "1px solid black"
                                  : "2px solid black",
                            }}
                          >
                            {`${item.attendeTawajahTalab ?? 0} / ${
                              item.totalTawajahTalab ?? 0
                            }`}{" "}
                            (
                            {item.tawajahTalab
                              ? item.tawajahTalab.toFixed(2) + "%"
                              : "0.0%"}
                            )
                          </td>
                          <td
                            style={{
                              border: "2px solid black",
                            }}
                          >
                            {item.totalPercentage
                              ? item.totalPercentage.toFixed(2) + "%"
                              : "0.0%"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <NoResult />
              )
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default UnitWiseEventAttendance;
